(function() {

  addEventListener("trix-attachment-add", function(event) {
    if (event.attachment.file) {
      uploadFileAttachment(event.attachment)
    }
  })

  function uploadFileAttachment(attachment) {
    uploadFile(attachment, setProgress, setAttributes)

    function setProgress(progress) {
      attachment.setUploadProgress(progress)
    }

    function setAttributes(attributes) {
      attachment.setAttributes(attributes)
    }
  }

  function uploadFile(attachment) {
    var file, form, xhr;
    file = attachment.file;
    form = new FormData;
    form.append('Content-Type', file.type);
    form.append('s3file[file]', file);
    xhr = new XMLHttpRequest;
    xhr.open('POST', '/s3files', true);
    xhr.setRequestHeader("X-CSRF-Token", Rails.csrfToken());

    xhr.upload.onprogress = function(event){
      var progress = event.loaded / event.total * 100;
      attachment.setUploadProgress(progress);
    }
  
    xhr.onload = function(){
      var data = JSON.parse(xhr.responseText);
      return attachment.setAttributes({
        url: data.document_url,
        href: data.document_url
      })
    }

    xhr.send(form)
  }

})();